import { render, staticRenderFns } from "./AttendanceReview.vue?vue&type=template&id=336cb636&scoped=true&"
import script from "./AttendanceReview.vue?vue&type=script&lang=ts&"
export * from "./AttendanceReview.vue?vue&type=script&lang=ts&"
import style0 from "./AttendanceReview.vue?vue&type=style&index=0&id=336cb636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336cb636",
  null
  
)

component.options.__file = "AttendanceReview.vue"
export default component.exports